// Taken from (for Sentry error support): https://github.com/vercel/next.js/blob/d2caaeab6491f1be80b3779b83e2902fc73223f9/examples/with-sentry/pages/_app.js
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import '@stripe/stripe-js'; // This is needed to run the stripe fraud tracking on every page
import * as Fathom from 'fathom-client';

// https://nextjs.org/docs/basic-features/built-in-css-support#adding-a-global-stylesheet
import './layout.scss';

const FATHOM_SITE_ID =
  process.env.FATHOM_SITE_ID || process.env.NEXT_PUBLIC_FATHOM_SITE_ID;

const App = ({ Component, pageProps, err }) => {
  const router = useRouter();

  useEffect(() => {
    Fathom.load(FATHOM_SITE_ID, {
      // Custom domain, must track what is set in https://app.usefathom.com/#/settings/domains
      url: 'https://ziggy-stardust-welcome.resist.bot/script.js',
      includedDomains: ['resist.bot'],
    });

    function onRouteChangeComplete() {
      Fathom.trackPageview();
    }
    // Record a pageview when route changes
    router.events.on('routeChangeComplete', onRouteChangeComplete);

    // Unassign event listener
    return () => {
      router.events.off('routeChangeComplete', onRouteChangeComplete);
    };
  }, [router.events]);

  // Workaround for https://github.com/vercel/next.js/issues/8592
  return <Component {...pageProps} err={err} />;
};

App.propTypes = {
  // Both for now to bridge Next10/11 and newer react features
  Component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  pageProps: PropTypes.object.isRequired,
  err: PropTypes.object,
};

export default App;
